export default "__VITE_ASSET__CnGqBLML__"